import { Accordion, Alert, Stack } from "@mantine/core";
import { YearPickerInput } from "@mantine/dates";
import { IconCalendarWeek } from "@tabler/icons-react";
import { useState } from "react";
import { useParams } from "react-router";
import { useOperators } from "../../../../hooks/useOperators";
import { useVariantSites } from "../../../../hooks/useVariantSites";
import { AlertPresets } from "../../../../mantine/mantinePresets";
import { OperatorFeatures } from "../../../../urls";
import { THIS_YEAR } from "../../../../utils/dates";
import { LoadOrError } from "../../../LoadOrError/LoadOrError";
import { EARLIEST_YEAR, INITIAL_YEAR } from "../../common";
import { AvailabilityWidget } from "./AvailabilityWidget/AvailabilityWidget";
import "./EnergyDataElectricityTax.scss";
import { StromsteuerSalesCard } from "./StromsteuerSalesCard";

interface EnergyDataElectricityTaxProps {
  variantId: number;
}

function EnergyDataElectricityTax({
  variantId
}: EnergyDataElectricityTaxProps) {
  const { projectId } = useParams();

  const [year, setYear] = useState(INITIAL_YEAR);

  const { error, isLoading, sites } = useVariantSites(variantId);

  const { data: companies, error: companiesError } = useOperators(
    {
      activeFeatures: [OperatorFeatures.Stromsteuer],
      project_id: projectId
    },
    { enabled: Boolean(projectId) }
  );

  return (
    <Stack>
      <LoadOrError error={companiesError}>
        {companies?.length === 0 && <StromsteuerSalesCard />}
      </LoadOrError>
      <LoadOrError error={error} loading={isLoading}>
        <Stack className="EnergyDataElectricityTax">
          {sites.length > 0 && projectId ? (
            <>
              <YearPickerInput
                className="year-picker"
                label="Meldejahr"
                labelProps={{ mb: 0 }}
                leftSection={<IconCalendarWeek />}
                maxDate={new Date(THIS_YEAR, 0, 1)}
                minDate={new Date(EARLIEST_YEAR, 0, 1)}
                value={new Date(year, 0, 1)}
                onChange={(newValue) =>
                  setYear(
                    newValue ? new Date(newValue).getFullYear() : INITIAL_YEAR
                  )
                }
              />
              <Accordion
                defaultValue={
                  sites.length === 1 ? [sites[0].id.toString()] : []
                }
                multiple
                w="100%"
              >
                {sites.map((site) => (
                  <AvailabilityWidget
                    key={site.id}
                    projectId={projectId}
                    siteId={site.id}
                    siteName={site.name}
                    year={year}
                  />
                ))}
              </Accordion>
            </>
          ) : (
            <Alert
              color={AlertPresets.warning.color}
              icon={AlertPresets.warning.icon}
              w="100%"
            >
              Es sind noch keine Liegenschaften konfiguriert.
            </Alert>
          )}
        </Stack>
      </LoadOrError>
    </Stack>
  );
}

export { EnergyDataElectricityTax, EnergyDataElectricityTaxProps };
